import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import Auth from "@/lib/common/auth";

// 单面试候选人统计 -- 开始
export class CandidateCountSearch extends Model {
  examId = 0; // 面试id筛选 否则全公司下
  examVersionId = 0; // 面试版本id筛选 需同时筛选examId
}

export class CandidateFinish extends Model {
  all = 0; // 全部
  noAudit = 0; // 评估-待评估
  auditPass = 0; // 评估-通过
  auditWait = 0; // 评估-待定
  auditRefuse = 0; // 评估-拒绝
  aiRecommendStatusNotRecommend = 0; // AI推荐-不推荐
  aiRecommendStatusNormal = 0; // AI推荐-一般
  aiRecommendStatusRecommend = 0; // AI推荐-推荐
  aiRecommendStatusVeryRecommend = 0; // AI推荐-非常推荐
}

export class CandidateCount extends Model {
  all = 0; // 全部人数
  notSignIn = 0; // 未签到
  signIn = 0; // 已签到
  answering = 0; // 答题中
  finish = new CandidateFinish();
  inviteNumber = 0; // 邀请人数(已通知+公开邀请)
  joinNumber = 0; // 参面人数(已登记+答题中+已交卷-已交卷面试过期自动结束)
  finishNumber = 0; // 完面人数(已交卷正常+已交卷系统自动结束)

  static get(param: CandidateCountSearch) {
    return request
      .postInterviewApi("hr/dashboard/candidateCount", param)
      .then(resp => {
        return new CandidateCount().assign(resp.data.data);
      });
  }
}
// 单面试候选人统计 -- 结束

// 多面试候选人统计 -- 开始
export class ExamCandidateSearch extends Model {
  companyId = Auth.companyId;
  examIdList: number[] = [];
}

export class ExamCandidateCountItem extends CandidateCount {
  examId = 0;
  examVersionId = 0; // 前端字段

  get finishCount() {
    return this.finish.all;
  }

  get beforeStartCount() {
    return this.signIn + this.notSignIn;
  }

  get playingCount() {
    return this.answering;
  }
}

export class ExamCandidateCount extends Model {
  list = [new ExamCandidateCountItem()];

  static getCandidateCount(param: ExamCandidateSearch) {
    return request
      .postInterviewApi("hr/exam/candidateCount", param)
      .then(resp => {
        return new ExamCandidateCount().assign(resp.data.data);
      });
  }
}
// 多面试候选人统计 -- 结束
